<template>
  <div class="call-fb-container">
    <div class="call-fb-header">
      <CallFbHeader
        v-model:caller-ids="selectedCallerIds"
        v-model:start-date="selectedStartDate"
        v-model:end-date="selectedEndDate"
        v-model:default-call-result-type-ids="selectedDefaultCallResultTypeIds"
        v-model:custom-call-result-type-ids="selectedCustomCallResultTypeIds"
        v-model:call-connection-points="selectedCallConnectionPoints"
      />
    </div>
    <div class="call-fb-main-content">
      <div class="call-fb-main-content-left">
        <CallFbCharts
          :caller-ids="selectedCallerIds"
          :start-date="selectedStartDate"
          :end-date="selectedEndDate"
          :default-call-result-type-ids="selectedDefaultCallResultTypeIds"
          :custom-call-result-type-ids="selectedCustomCallResultTypeIds"
          :call-connection-points="selectedCallConnectionPoints"
        />
      </div>
      <div class="call-fb-main-content-right">
        <CallFbCards
          :caller-ids="selectedCallerIds"
          :start-date="selectedStartDate"
          :end-date="selectedEndDate"
          :default-call-result-type-ids="selectedDefaultCallResultTypeIds"
          :custom-call-result-type-ids="selectedCustomCallResultTypeIds"
          :call-connection-points="selectedCallConnectionPoints"
          :call-result-id="selectedCallResultId"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineModel } from 'vue';
import CallFbCards from './CallFbCards.vue';
import CallFbCharts from './CallFbCharts.vue';
import CallFbHeader from './CallFbHeader.vue';

const selectedCallerIds = defineModel<number[]>('callerIds', { default: () => [] });
const selectedStartDate = defineModel<string | undefined>('startDate');
const selectedEndDate = defineModel<string | undefined>('endDate');
const selectedDefaultCallResultTypeIds = defineModel<number[]>('defaultCallResultTypeIds', { default: () => [] });
const selectedCustomCallResultTypeIds = defineModel<number[]>('customCallResultTypeIds', { default: () => [] });
const selectedCallConnectionPoints = defineModel<string[]>('callConnectionPoints', { default: () => [] });
const selectedCallResultId = defineModel<number | null>('callResultId', { default: null });
</script>

<style lang="scss" scoped>
.call-fb-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.call-fb-main-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
  min-height: 0;
}

.call-fb-main-content-left {
  width: 280px;
  height: 100%;
  overflow-y: auto;
  flex-shrink: 0;
  border-right: 1px solid $bdcolor-base;
}

.call-fb-main-content-right {
  height: 100%;
  overflow-y: auto;
  flex-grow: 1;
}
</style>
